// extracted by mini-css-extract-plugin
export var icon = "accountAccessForm-module--icon--61df6";
export var successContainer = "accountAccessForm-module--successContainer--845bc";
export var successHeadline = "accountAccessForm-module--successHeadline--0c1c3";
export var successSubhead = "accountAccessForm-module--successSubhead--20fcc";